/**
 * Suppress benign Chrome ResizeObserver messages so react-error-overlay / WDS overlay does not flash.
 * Imported first from index.js; public/index.html also registers early for the same reason.
 */
const RESIZE_OBSERVER_NOISE =
  /ResizeObserver loop (?:limit exceeded|completed with undelivered notifications)/i;

function messageFromEvent(e) {
  if (!e) return '';
  if (typeof e.message === 'string') return e.message;
  if (e.error && typeof e.error.message === 'string') return e.error.message;
  return '';
}

function swallowIfNoise(e) {
  if (RESIZE_OBSERVER_NOISE.test(messageFromEvent(e))) {
    e.stopImmediatePropagation();
    if (typeof e.preventDefault === 'function') e.preventDefault();
  }
}

window.addEventListener('error', swallowIfNoise, true);

window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason && (e.reason.message || String(e.reason));
  if (typeof msg === 'string' && RESIZE_OBSERVER_NOISE.test(msg)) {
    e.preventDefault();
  }
});
